<template>
  <div class="sync-fullscreen">
    <div class="sync-card">
      <img src="media/logos/logo_nuts_1.png" alt="Nuts PDV" class="sync-logo" />
      <h2>Sincronizando dados</h2>
      <p class="text-muted">
        Aguarde enquanto baixamos produtos e clientes para o PDV offline.
      </p>

      <div class="progress mt-4 mb-2" style="height: 12px;">
        <div
          class="progress-bar bg-primary"
          role="progressbar"
          :style="{ width: progresso + '%' }"
          :aria-valuenow="progresso"
          aria-valuemin="0"
          aria-valuemax="100"
        ></div>
      </div>
      <p class="status-text">{{ statusSync }}</p>

      <div v-if="erro" class="alert alert-danger mt-3 text-left">
        {{ erro }}
        <br />
        <button class="btn btn-sm btn-outline-danger mt-2" @click="iniciarSync">
          Tentar novamente
        </button>
      </div>

      <div v-if="concluido" class="alert alert-success mt-3">
        ✓ Sincronização concluída! Abrindo o PDV...
      </div>
    </div>
  </div>
</template>

<script>
import SincronizacaoService from "@/services/SincronizacaoService";

export default {
  name: "PdvSincronizacaoInicial",

  data() {
    return {
      progresso: 0,
      statusSync: "Iniciando...",
      erro: null,
      concluido: false,
    };
  },

  async mounted() {
    if (!this.$isDesktop) {
      this.$router.push({ name: "pdvDesktopLogin" });
      return;
    }
    await this.iniciarSync();
  },

  methods: {
    async iniciarSync() {
      this.erro = null;
      this.concluido = false;
      this.progresso = 0;
      this.statusSync = "Iniciando...";

      try {
        const apiUrl = await this.$electron.config.get("api_url");
        const token = await this.$electron.config.get("api_token");

        if (!apiUrl || !token) {
          this.erro = "Configuração da API não encontrada. Faça login novamente.";
          return;
        }

        await SincronizacaoService.sincronizarInicial({
          apiUrl,
          token,
          onProgress: (pct, msg) => {
            this.progresso = pct;
            this.statusSync = msg;
          },
        });

        this.progresso = 100;
        this.statusSync = "Sincronização concluída!";
        this.concluido = true;

        setTimeout(() => {
          this.$router.push({ name: "pdvDesktopDashboard" });
        }, 1500);
      } catch (e) {
        this.erro = `Erro na sincronização: ${e.message}`;
      }
    },
  },
};
</script>

<style scoped>
.sync-fullscreen {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f7fa;
}
.sync-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
  padding: 3rem 2.5rem;
  width: 100%;
  max-width: 480px;
  text-align: center;
}
.sync-logo {
  max-height: 80px;
  margin-bottom: 1.5rem;
}
.status-text {
  font-size: 0.9rem;
  color: #6c757d;
  min-height: 1.4em;
}
</style>
